import type { ApolloError } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useEffect } from 'react';

import { GetUrnDocument } from '../graphql';

type GetUrnResult = {
  loading: boolean;
  error?: ApolloError;
  hasExternalLinkError: boolean;
  urn?: string;
};

export const useGetUrn = (url: string): GetUrnResult => {
  const [getUrn, { loading, data, error }] = useMutation(GetUrnDocument);

  useEffect(() => {
    getUrn({
      variables: { url },
    });
  }, [url, getUrn]);

  const hasExternalLinkError = data?.socialCreateExternalLink?.success === null;
  const urn = data?.socialCreateExternalLink?.success?.urn;

  return {
    loading,
    error,
    hasExternalLinkError,
    urn,
  };
};
